import { render, staticRenderFns } from "./WineListByTheGlass.vue?vue&type=template&id=2d33e7d0&"
import script from "./WineListByTheGlass.vue?vue&type=script&lang=js&"
export * from "./WineListByTheGlass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports